import background from "./paul.png";

const Feedback = () => {


    return <section className="bg-slate-100 py-20">
        <div className="shadow-xl shadow-slate-200 max-w-[900px] mx-auto bg-white rounded-3xl overflow-hidden grid grid-cols-12">
            <div className="bg-orange-500 bg-cover col-span-5" style={{backgroundImage:'url('+background+')'}}></div>
            <div className="col-span-7">
                <div className="p-20">
                    <p className="mb-5 text-3xl">"CSS Hero Animator is very smooth and streamlined to work with"</p>
                    <div className="flex items-center">
                    <div>
                        <b>Paul C.</b>
                        <div className='-mt-2 text-slate-500'>wptuts.co.uk</div>
                    </div>
                    <a target="_blank" href="https://youtu.be/Ty_a2_84r-I?t=621" className="bg-orange-50 text-orange-500 hover:bg-orange-100 ml-auto rounded-xl py-1 px-3">Watch Video &rarr;</a>
                    </div>
                </div>
                
            </div>
        </div>

    </section>
}

export default Feedback